export default __webpack_public_path__ + "static/media/03-hole-hi-dx.74f949af.png";